import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { bypassNavigationBlock } from '../../hooks/useNavigationBlock';
import './ImpersonationBanner.css';

function ImpersonationBanner() {
  const { t } = useTranslation();
  const { user, isImpersonating, originalUser, stopImpersonating } = useAuth();

  if (!isImpersonating) return null;

  const handleReturn = () => {
    stopImpersonating();
    bypassNavigationBlock();
    window.location.href = '/';
  };

  const getOriginalRoleLabel = () => {
    if (originalUser?.isAdmin) return 'ADMIN';
    if (originalUser?.isExcon) return 'EXCON';
    return originalUser?.nation || '';
  };

  return (
    <div className="impersonation-banner">
      <div className="impersonation-banner-content">
        <span className="impersonation-banner-icon">&#128065;</span>
        <span className="impersonation-banner-text">
          {t('components.impersonationBanner.viewingAs')} <strong>{user?.nation}</strong>
          {originalUser && (
            <> ({t('components.impersonationBanner.loggedInAs', { nation: getOriginalRoleLabel() })})</>
          )}
        </span>
        <button className="impersonation-banner-btn" onClick={handleReturn}>
          &#8617; {t('components.impersonationBanner.returnTo', { nation: getOriginalRoleLabel() })}
        </button>
      </div>
    </div>
  );
}

export default ImpersonationBanner;
